import { Button } from "@/components/ui/button";
import { formatActivityTime, formatKwacha, groupActivityEntries, type ActivityEntry } from "@/lib/activity";

export function ActivityTimeline({
  entries,
  emptyText,
  showActor = false,
  onDeleteSale,
  deletingSaleId,
}: {
  entries: ActivityEntry[];
  emptyText: string;
  showActor?: boolean;
  onDeleteSale?: (saleId: string) => void;
  deletingSaleId?: string | null;
}) {
  const groups = groupActivityEntries(entries);

  if (entries.length === 0) {
    return <p className="text-sm text-muted-foreground text-center py-4">{emptyText}</p>;
  }

  return (
    <div className="space-y-6">
      {groups.map((group) => (
        <div key={group.label}>
          <div className="text-xs font-semibold tracking-[0.16em] text-muted-foreground mb-3">
            {group.label}
          </div>
          <div className="space-y-2">
            {group.items.map((entry) => (
              <div
                key={`${entry.type}-${entry.id}`}
                className="flex items-center gap-3 rounded-md border border-border px-3 py-3"
              >
                <div className="w-14 shrink-0 text-xs font-medium text-muted-foreground">
                  {formatActivityTime(entry.occurred_at)}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-medium text-foreground">
                    {entry.type === "sale"
                      ? `Sale - ${entry.title}${entry.quantity ? ` x ${entry.quantity}` : ""}`
                      : `Expense - ${entry.title}`}
                  </div>
                  {showActor && entry.actor_label && (
                    <div className="text-xs text-muted-foreground">
                      {entry.actor_label}
                    </div>
                  )}
                </div>
                <div className="shrink-0 text-sm font-semibold text-foreground">
                  {formatKwacha(entry.amount)}
                </div>
                {entry.type === "sale" && entry.canDelete && onDeleteSale && (
                  <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    disabled={deletingSaleId === entry.id}
                    onClick={() => onDeleteSale(entry.id)}
                    className="shrink-0 text-destructive hover:text-destructive"
                  >
                    {deletingSaleId === entry.id ? "Deleting..." : "Delete"}
                  </Button>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
